import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="gens-complex">
                <div className="gens-complex__title-container">
                    <CommonTitle className="gens-complex__title">Сложности</CommonTitle>
                    <CommonUsualText className="gens-complex__subtitle">
                        GenerationS&nbsp;&mdash; проект, который развивался очень стремительно.
                        Достаточно посмотреть на&nbsp;таймлайн проекта. Начиная с&nbsp;2016 года
                        фактически каждый год мы&nbsp;имели дело с&nbsp;новой схемой проведения
                        экспертизы. Траектория движения заявки часто зависела от&nbsp;стадии
                        стартапа.
                    </CommonUsualText>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
